import { HomePage } from './../home/home.page';
import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import ArticleCategory from '../../../smoothr-web-app-core/models/ArticleCategory';
import { ActivatedRoute, Router } from '@angular/router';
import { ToOrderButtonComponent } from '../../components/to-order-button/to-order-button.component';
import { IonSearchbar, ModalController } from '@ionic/angular';
import { ModalInfoComponent } from '../../components/modal-info/modal-info.component';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleGroup from '../../../smoothr-web-app-core/models/ArticleGroup';
import { AppComponent } from '../../app.component';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { OrderPage } from '../order/order.page';
import { TranslateService } from '@ngx-translate/core';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import { OrderType } from '../../../smoothr-web-app-core/enums/OrderType';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { environment } from '../../../environments/environment';
import {
	axiosErrorToMessage,
	defaultsToArticleOption,
	getAvailability,
	isAvailable,
	isVenueOpen,
	resolveByType,
	sleep,
} from '../../../smoothr-web-app-core/utils/utils';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import { RecomendationArticleModalComponent } from 'src/app/components/recomendation-article-modal/recomendation-article-modal.component';
import { ConfirmYearModalComponent } from 'src/app/components/confirm-year-dialog/confirm-year-modal.component';
import { debounceTime, Subject } from 'rxjs';
import { IonContentCustomEvent, ScrollDetail } from '@ionic/core';
import { ValidationUtils } from 'src/smoothr-web-app-core/utils/validation-utils';
import { TimeUtils } from 'src/smoothr-web-app-core/utils/time-utils';
import Tag from 'src/smoothr-web-app-core/models/Tag';
import Order from 'src/smoothr-web-app-core/models/Order';

@Component({
	selector: 'app-menu',
	templateUrl: './menu.page.html',
	styleUrls: ['menu.page.scss'],
	standalone: false,
})
export class MenuPage extends RepositoryDirective implements OnInit {
	static url = 'menu';

	@ViewChild(ToOrderButtonComponent, { static: false }) toOrderButton;
	@ViewChild(IonSearchbar, { static: false }) searchBar;
	@ViewChild('articleContent', { static: false }) articleList;
	@ViewChild('categoryList', { static: false }) categoryList;

	environment = environment;
	scrollEvents = true;
	loading = false;
	searchTerm = '';
	categories: ArticleCategory[] = [];
	moment = moment;
	PreorderType = PreorderType;
	searchBarOpen = false;
	showBanner = true;
	prevIndex = -1;

	showBasket = false;
	venueOpen = true;
	venuePanic = false;
	public openedCategory: ArticleCategory = null;
	scroll$ = new Subject<any>();
	notificationTimeout: any;
	public messageNotification = '';

	get preorderType(): PreorderType {
		return this.order.preorder?.type;
	}

	private translate: TranslateService = inject(TranslateService);
	private modalCtrl: ModalController = inject(ModalController);
	private snackbarCtrl: MatSnackBar = inject(MatSnackBar);
	private router: Router = inject(Router);
	private route: ActivatedRoute = inject(ActivatedRoute);
	private analytics: AnalyticsService = inject(AnalyticsService);
	protected repository: RepositoryService;

	constructor() {
		const repository = inject(RepositoryService);
		super();
		this.repository = repository;
	}

	private _selectedCategoryIndex = 0;

	get selectedCategoryIndex(): number {
		return this._selectedCategoryIndex;
	}

	set selectedCategoryIndex(value) {
		if (this._selectedCategoryIndex === value) {
			return;
		}
		this._selectedCategoryIndex = value;
		this.scrollTo(value);
	}

	get selectedCategory(): ArticleCategory {
		return this.categories[this.selectedCategoryIndex];
	}

	get active(): boolean {
		return (
			this.order &&
			OrderUtils.articleGroupsTotalPrice(
				this.order.orderedArticles,
				this.order.type,
				this.order.preorder.type,
				this.order.terminalorder ? this.order.terminalorder.type : null
			) > 0
		);
	}

	get index(): number {
		return this.categories.findIndex(category => category._id === this.selectedCategory._id);
	}

	static async navigate(router: Router) {
		await router.navigateByUrl(MenuPage.url);
	}

	ngOnInit() {
		super.ngOnInit();
		switch (window.location.pathname) {
			case '/' + OrderPage.url:
				break;
			case '/' + OrderPage.paymentCancelUrl:
				console.log(this.translate.instant('order.payment_cancel'));
				this.snackbarCtrl.open(this.translate.instant('order.payment_cancel'), null, {
					duration: 2000,
				});
				break;
			case '/' + OrderPage.paymentFailUrl:
				console.log(this.translate.instant('order.payment_fail'));
				this.snackbarCtrl.open(this.translate.instant('order.payment_fail'), null, {
					duration: 5000,
				});
				break;
		}

		this.loading = true;
		this.repository
			.getVenue(this.order && this.order.venue ? this.order.venue : environment.customerGroup + '_master')
			.then(venue => {
				this.repository.venue.emit(venue);
			});

		this.loading = false;

		this.route.queryParams.subscribe(async v => {
			if (v?.categoryId && this.categories) {
				await sleep(300);
				const foundIndex = this.categories.findIndex(cat => cat._id === v?.categoryId);
				if (foundIndex >= 0) {
					this.openedCategory = this.categories[foundIndex];

					this.selectedCategoryIndex = foundIndex;
					await this.scrollArticleListTo(foundIndex);
					await this.scrollCategoryListTo(foundIndex);
				}
			}
		});
		this.scroll$.pipe(debounceTime(100)).subscribe(event => this.onScroll(event));
	}

	largeScreen(): boolean {
		return AppComponent.largeScreen;
	}
	// async openSelectTableModal(openByToolbar?: boolean) {
	// 	if (this.venue && this.order.preorder.type === PreorderType.INSIDE) {
	// 		if (this.order.tableNumber === 'preorder_table' || openByToolbar) {
	// 			const selectTable = await SelectTableModalComponent.show(this.modalCtrl, this.venue, this.order);
	// 			if (selectTable) {
	// 				this.order.tableNumber = selectTable.table;
	// 				this.order.table = selectTable.tableId;
	// 				this.repository.order.emit(this.order);
	// 			}
	// 		}
	// 	}
	// }
	async scrollTo(index: number) {
		if (this.categories.length - 1 < index || index < 0) {
			return;
		}
		if (this.searchTerm !== '') {
			await sleep(100);
			await this.scrollTo(index);
			return;
		}
		if (this.selectedCategoryIndex !== index) {
			this.selectedCategoryIndex = index;
			await this.scrollCategoryListTo(index);
			await this.scrollArticleListTo(index);
		}
	}

	async checkIfReachedBottom(event: IonContentCustomEvent<ScrollDetail>) {
		const scrollTop = event.detail.currentY;
		const scrollHeight = event.target.scrollHeight;
		const clientHeight = (await event.target.getScrollElement()).scrollHeight;

		const atBottom = scrollTop + scrollHeight >= clientHeight - 20;

		if (atBottom) {
			console.log('Reached bottom!');
			return true;
		}

		return false;
	}

	async onScroll(event: IonContentCustomEvent<ScrollDetail>) {
		if (await this.checkIfReachedBottom(event)) {
			return;
		}

		const categoryElements = [...this.articleList.el.children];
		const categoryIndex = categoryElements
			.map(el => el.offsetTop)
			.map((value, index, array) => {
				return (
					value <= event.detail.currentY &&
					((index < array.length - 1 && event.detail.currentY < array[index + 1]) || index === array.length - 1)
				);
			})
			.findIndex(value => value);
		// console.log('this.prevIndex', this.prevIndex);
		// console.log('categoryIndex', categoryIndex);
		if (this.prevIndex === categoryIndex) {
			return;
		}

		if (categoryIndex > this.prevIndex && this.prevIndex >= 0) {
			this.showBanner = false;
		} else {
			this.showBanner = true;
		}

		if (this.scrollEvents) {
			this.selectedCategoryIndex = categoryIndex;
			await this.scrollCategoryListTo(categoryIndex);
		}
		this.prevIndex = categoryIndex;
	}
	private async scrollCategoryListTo(index: number) {
		if (
			index < 0 ||
			!this.categoryList?.nativeElement?.children[index] ||
			(!this.categoryList?.nativeElement?.scrollTo && !this.categoryList?.nativeElement?.scrollLeft)
		) {
			return;
		}
		this.categoryList.nativeElement.scrollTo(this.categoryList.nativeElement.children[index].offsetLeft - 25, 100);
		await sleep(100);
	}
	async openModal(item: Article, category: ArticleCategory, showRec: boolean = true) {
		// const result = await ConfirmYearModalComponent.show(this.modalCtrl)
		// console.log(result);
		// return

		if (this.loading) {
			return;
		}
		if (!this.venueOpen || this.venuePanic) {
			this.snackbarCtrl.open(this.translate.instant('menu_page.venue_panic_or_closed'), null, {
				duration: 2000,
			});
			return;
		}

		const articleGroup = new ArticleGroup();
		articleGroup.article = item;
		articleGroup.groups.push(...defaultsToArticleOption(item, [], item.defaults, this.order.preorder.type));
		articleGroup.quantity = 1;
		console.log('item', item);

		const modal = await this.modalCtrl.create({
			cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
			component: ModalInfoComponent,
			componentProps: {
				articleGroup,
			},
			mode: 'ios',
			backdropDismiss: true,
			showBackdrop: true,
		});
		await modal.present();
		const response = await modal.onDidDismiss();
		if (response.data && response.data.articleGroup) {
			const canAdd = await MenuPage.checkAge(
				response.data.articleGroup,
				this.order,
				this.modalCtrl,
				this.snackbarCtrl,
				this.translate
			);
			if (!canAdd) {
				return;
			}
			OrderUtils.addToOrder(this.order, response.data.articleGroup, this.analytics);
			this.repository.order.emit(this.order);

			if (showRec) {
				const mainRecommendations = this.categories.find(cat =>
					cat.articles.some(art => art._id === item._id)
				)?.mainRecommendations;

				if (mainRecommendations.length > 0) {
					let categoryArticles = [].concat(
						...this.venue.articleCategories.filter(cat => !cat.hidden).map(it => it.articles)
					) as Article[];
					categoryArticles = categoryArticles.filter(
						article =>
							article.visible &&
							article.isActive &&
							isAvailable(article.availability, this.order.type, this.order.preorder.type) &&
							(!article?.availableHours ||
								article?.availableHours?.length === 0 ||
								(article.availableHours && TimeUtils.doesHoursMatchNow(article.availableHours)))
					);

					const categoryArticlesMap = new Map(categoryArticles.map(it => [it._id, it]));
					const recommendedArticles: Article[] = [];

					mainRecommendations.forEach(it => {
						if (categoryArticlesMap.has(it)) {
							recommendedArticles.push(categoryArticlesMap.get(it));
						}
					});
					if (recommendedArticles.some(art => art.visible)) {
						await RecomendationArticleModalComponent.show(
							this.modalCtrl,
							recommendedArticles,
							category,
							this.order,
							this.venue,
							this.translate.instant('new_design_text.recomendation_example')
						);
					}
				}
			}
		}
	}

	async addToBasketImmediately(item: Article, category: ArticleCategory) {
		if (!this.venueOpen || this.venuePanic) {
			this.snackbarCtrl.open(this.translate.instant('menu_page.venue_panic_or_closed'), null, {
				duration: 2000,
			});
			return;
		}
		const articleGroup = new ArticleGroup();
		articleGroup.article = item;
		articleGroup.groups.push(...defaultsToArticleOption(item, [], item.defaults, this.order?.preorder.type));
		articleGroup.quantity = 1;
		articleGroup.categoryName = category.name;

		if (ValidationUtils.areGroupsValid(articleGroup, [])) {
			const canAdd = await MenuPage.checkAge(
				articleGroup,
				this.order,
				this.modalCtrl,
				this.snackbarCtrl,
				this.translate
			);
			if (!canAdd) {
				return;
			}
			OrderUtils.addToOrder(this.order, articleGroup, this.analytics);
			this.repository.order.emit(this.order);

			this.showNotification(
				this.translate.instant('menu_page.add_to_basket.full', { name: articleGroup.article.name.de })
			);
		} else {
			this.snackbarCtrl.open(
				`article ${item.name[this.translate.currentLang]} has validation errors while adding to your basket`,
				null,
				{
					duration: 3000,
				}
			);
		}
	}

	static validateYears(articleGroup: ArticleGroup) {
		return Math.max(
			articleGroup.article.fsk,
			articleGroup.groups
				.map(group => group.article.fsk)
				.reduce((previousValue, currentValue) => Math.max(previousValue, currentValue), 0)
		);
	}

	onSearchTermChanged(event) {
		this.searchTerm = event.detail.value;
		this.reloadCategories();
	}

	reloadCategories(
		params: {
			categoryId: string;
			articleTagIndentifier: string;
		} = null
	) {
		if (!this.venue) {
			this.categories = [];
			return;
		}

		const lowerSearchTerm = this.searchTerm && this.searchTerm !== '' ? this.searchTerm.toLocaleLowerCase() : null;
		const categories = this.venue.articleCategories
			.filter(c => !c.hidden)
			.map(category => {
				const tagIdentifierFromParams =
					params && category._id === params.categoryId && params.articleTagIndentifier
						? params.articleTagIndentifier
						: null;
				const cat: ArticleCategory = {
					...category,
					...(tagIdentifierFromParams ? { filterArticleByTag: tagIdentifierFromParams } : {}),

					articles: category.articles.filter(article => {
						const available = getAvailability(article, OrderType.PREORDER, this.preorderType);
						const availableByTag = tagIdentifierFromParams
							? !!article.tags.find(it => it.identifier === tagIdentifierFromParams)
							: true;

						const keys = [
							article.name.es.toLowerCase(),
							article.name.en.toLowerCase(),
							category.name.es.toLowerCase(),
							category.name.en.toLowerCase(),
						];

						const availableBySearch = lowerSearchTerm ? keys.some(key => key.includes(lowerSearchTerm)) : true;

						return availableBySearch && availableByTag && available;
					}),
				};

				return cat;
			})
			.filter(category => {
				const availabilityOK =
					!category.availability || resolveByType(category.availability, OrderType.PREORDER, this.preorderType);

				return availabilityOK && category.articles.length > 0;
			});

		this.categories = categories;
		return;
	}

	onVenue() {
		super.onVenue();
		if (!this.venue) {
			this.repository
				.getVenue(this.order && this.order.venue)
				.then(venue => {
					this.repository.venue.emit(venue);
				})
				.catch(_ => {
					this.reloadCategories();
					this.selectedCategoryIndex = 0;
				});
			return;
		}
		this.reloadCategories();
		this.reloadPanicAndOpening();
		this.selectedCategoryIndex = 0;
	}

	onVenueError(error) {
		super.onVenueError(error);
		this.snackbarCtrl.open(axiosErrorToMessage(this.translate, error));
		this.loading = false;
		this.snackbarCtrl.open(
			this.translate.instant('menu_page.venue_timed_out'),
			this.translate.instant('menu_page.venue_timed_out_action')
		);
	}

	private async scrollArticleListTo(index: number) {
		if (!this.articleList) {
			return;
		}
		await this.articleList.scrollToPoint(0, this.articleList.el.children[index].offsetTop + 1, 300);
	}
	goToHome() {
		HomePage.navigate(this.router);
	}
	changeSearchbar() {
		this.searchBarOpen = !this.searchBarOpen;
	}
	clearInput() {
		this.searchTerm = '';
		this.searchBarOpen = !this.searchBarOpen;
		this.reloadCategories();
	}

	async reloadPanicAndOpening() {
		this.loading = true;
		if (!this.venue) {
			this.venueOpen = false;
			this.venuePanic = false;
			this.loading = false;
			return;
		}

		this.venueOpen = isVenueOpen(this.venue);

		this.venuePanic = !this.venue?.isServiceActivated || this.venue?.panicEndAt.isAfter(moment());
		this.loading = false;
		console.log({ open: this.venueOpen, panic: this.venuePanic });
	}

	showNotification(message: string) {
		this.messageNotification = message;
		clearTimeout(this.notificationTimeout);

		// Set a new timeout
		this.notificationTimeout = setTimeout(() => {
			this.messageNotification = '';
		}, 3000);
	}

	async goToOrder() {
		const upSaleCategory = this.venue.articleCategories.find(category =>
			category.tags.some(tag => tag.identifier.includes('upsell_before_basket'))
		);

		if (
			upSaleCategory &&
			isAvailable(upSaleCategory.availability, this.order.type, this.order.preorder.type) &&
			upSaleCategory.articles.length
		) {
			const activeRecomendedArticles = upSaleCategory.articles.filter(
				art =>
					art.isActive &&
					art.visible &&
					isAvailable(art.availability, this.order.type, this.order.preorder.type) &&
					(!art.availableHours ||
						art?.availableHours?.length === 0 ||
						(art.availableHours && TimeUtils.doesHoursMatchNow(art.availableHours)))
			);

			if (activeRecomendedArticles.length !== 0) {
				await RecomendationArticleModalComponent.show(
					this.modalCtrl,
					activeRecomendedArticles,
					upSaleCategory,
					this.order,
					this.venue,
					this.translate.instant('new_design_text.recommendation_before_order')
				);
			}
		}
		this.router.navigateByUrl('order');
	}

	checkIfCategoryHasTag(category: ArticleCategory) {
		return category.tags.length > 0 && category.tags.find(it => it.identifier.includes('has_filter'));
	}

	getArrayOfFilters(category: ArticleCategory): Tag[] {
		const originalCategory = this.venue.articleCategories.find(it => it._id === category._id);

		const listOfTags: Tag[] = [].concat(
			...originalCategory.articles.map(article => {
				const articleTags = article.tags.filter(it => it.identifier.includes('filter_'));
				return articleTags;
			})
		);

		//remove duplicates

		return Array.from(new Map(listOfTags.map(tag => [tag.identifier, tag])).values()).sort(
			(a, b) => a?.sortOrder - b?.sortOrder
		);
	}

	addCategoryArticleFilter(categoryId: string, articleTagIndentifier: string) {
		this.reloadCategories({ categoryId: categoryId, articleTagIndentifier: articleTagIndentifier });
	}

	static async checkAge(
		articleGroup: ArticleGroup,
		order: Order,
		modalCtrl: ModalController,
		snackbarCtrl: MatSnackBar,
		translate: TranslateService
	) {
		const fsk = MenuPage.validateYears(articleGroup);

		if (fsk > 0 && (!order?.fsk || fsk > order?.fsk)) {
			const result = await ConfirmYearModalComponent.show(modalCtrl, fsk);
			if (result) {
				order.fsk = fsk;
				return true;
			} else {
				snackbarCtrl.open(translate.instant('confirm_year_modal.reject'), null, {
					duration: 4000,
				});
				return false;
			}
		}

		return true;
	}
}
